<template>
    <BaseDialog
        :showDialog="showGemaSoundfileDialog"
        maxDialogWidth="850"
        headline="lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_GEMA_SOUNDFILE_API"
        maxCardHeight="700"
        :persistent="true"
        :close="closeDialog"
    >

        <template v-slot:dialogText>
            <!--  overflow-y: scroll -->
            <!-- <div style="max-height: 500px;"> -->
             <v-container fluid v-if="showConfirmText">
                <v-row>
                    <v-col>
                        {{ confirmationText }}<br />
                        {{ approvalText }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseCheckbox :label="approvalAdvertisement" context="GemaSoundfileDialogApprovals" valueOuter="advertisement"/>
                        <BaseCheckbox :label="approvalTvRadio" context="GemaSoundfileDialogApprovals" valueOuter="tvRadio"/>
                        <BaseCheckbox :label="approvalOnline" context="GemaSoundfileDialogApprovals" valueOuter="online"/>
                        <BaseCheckbox :label="approvalClubDisco" context="GemaSoundfileDialogApprovals" valueOuter="clubDisco"/>
                    </v-col>
                </v-row>
            </v-container>

            <v-container v-else fluid>
                <v-row v-if="showProcessProgressbar">
                    <v-col>
                        <v-progress-linear
                            :active="sending"
                            indeterminate
                            color="dialogProgressbar"
                        ></v-progress-linear>
                    </v-col>
                </v-row> 
                <v-row v-if="showReportTable">
                    <v-col>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-left report-table-header" >{{ $t("lang_LABEL_TRACKS_ACTION_BULK_FILE_IMPORT_REPORT") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in data" :key="index">
                                        <td 
                                            :class="[
                                                    index != 0 && index % 4 == 0 ? 'report-table-file-name-row2' : ''
                                            ]"
                                        >
                                            {{ item }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
          <!-- </div> -->
        </template>

        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <BaseButton 
                            @click="submit()"
                            label="lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_BUTTON_CAPTION"
                            :disabled="submitButtonDisable"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>

    </BaseDialog>
</template>

<script>
import api2 from '@/api_alv'
import BaseDialog from '@/components/_base/BaseDialog'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "GemaSoundfileDialog",
    components: {
        BaseButton,
        BaseDialog,
        BaseCheckbox
    },
    data() {
        return {
            data: [],
            showProcessProgressbar: false,
            showReportTable: false,
            showConfirmText: true,
            polling: null,
            textInfo: "Confirm sending",
            processValue: 0,
            sending: false,
            closeButtonDisable: false,
            submitButtonDisable: false,
            sending: false,
            context: "GemaSoundfileDialogApprovals"
        }
    },
    computed: {
        confirmationText() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_CONFIRMATION_TEXT')
        },
        approvalText() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_APPROVAL_TEXT')
        },
        approvalAdvertisement() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_APPROVAL_ADVERTISEMENT')
        },
        approvalTvRadio() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_APPROVAL_TV_RADIO')
        },
        approvalOnline() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_APPROVAL_ONLINE')
        },
        approvalClubDisco() {
            return this.$t('lang_PUBLISHING_WORKS_GEMA_SOUNDFILE_APPROVAL_CLUB_DISCO')
        },
        showGemaSoundfileDialog: {
            get() { return this.$store.getters.getShowGemaSoundfileDialog },
            set(showGemaSoundfileDialog) { this.$store.commit('setShowGemaSoundfileDialog', showGemaSoundfileDialog) }
        },
        selectedWorks() {
            return this.$store.getters.getSelectedWorks
        },
        selection: {
            get() { return this.$store.getters['getGemaSoundfileDialogApprovalsCheckbox'] },
            set(value) { this.$store.commit('setGemaSoundfileDialogApprovalsCheckbox', value)}
        }
    },
    methods: {
        closeDialog() {
            if(this.sending) {
                return
            }
            this.showGemaSoundfileDialog = false
            this.processValue = 0
            this.showProcessProgressbar = false
            this.data = []
            this.polling = null
            this.showConfirmText = true
            this.showReportTable = false
            this.closeButtonDisable = false
            this.submitButtonDisable = false
            this.sending = false
            this.$store.commit('setSelectedWorks',[])
            this.$store.commit('setGemaSoundfileDialogApprovalsCheckbox',["advertisement", "tvRadio", "online", "clubDisco"])
        },
        async submit() {
            let response = await this.$store.dispatch('sendWorksGemaSoundfile')
            
            if(response.error === -1) {
                this.showConfirmText = false
                this.closeButtonDisable = true
                this.submitButtonDisable = true
                this.sending = true
                this.showProcessProgressbar = true
                this.showReportTable = true

                let processFileResponse = await this.processGemaSoundfile(response)

                if(processFileResponse.status === 'running') {
                    this.polling = setInterval(() => {
                        this.processGemaSoundfile(response) 
                    }, 5000)

                    setTimeout(() => { clearInterval(this.polling) }, 1800000)                    
                }
            } else {
                let message = this.$t(response.response.errorMsg)
                this.$store.commit('setSnackbar', { 
                    type: 'error', 
                    msg: message
                }) 
            }
        },
        async processGemaSoundfile(uploadResponse) {
            let result = await api2.getProgressOfProcess(uploadResponse.processId, this.polling).then(response => { return response })

            this.processValue = result.percent

            if(result.completeMsgArray.report){
                let table = []
                result.completeMsgArray.report.forEach(element => {
                    table.push(this.$t('lang_WORK') + ': ' + element.workTitle + " (" + element.workAlvId + ")")
                    table.push(this.$t('lang_TRACK') + ': ' + (element.trackTitle != null ? element.trackTitle + " (" + element.trackAlvId + ")" : ""))
                    table.push(element.validationMessage)
                    table.push(element.sendingMessage)
                });

                this.data = table
            }

            if(result.status === 'finished') {
                this.showProcessProgressbar = false
                this.closeButtonDisable = false
                this.processValue = 100
                this.sending = false
            }            
            return result
        }
    },
    beforeDestroy () {
	    clearInterval(this.polling)
    },
}

</script>